module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_1@3x.647d4355.png";